import { h } from '@stencil/core';
export class RangeSoftwareRegistrationTab {
  constructor() {
    this.url = undefined;
  }
  render() {
    return (h("div", { class: "range-software-registration" }, h("iframe", { class: "range-software-registration__iframe", src: this.url })));
  }
  static get is() { return "pes-range-software-registration-tab"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-software-registration-tab.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-software-registration-tab.css"]
    };
  }
  static get properties() {
    return {
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "url",
        "reflect": false
      }
    };
  }
}
